module.exports = __webpack_public_path__ + "media/images/amenities_icons/phone_booth-45a4e7cefe4efe8b205beaa0725cc222.svg";